'use client';

import { useState, useEffect } from 'react';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';

const IOS_APP_STORE_URL = 'https://apps.apple.com/app/summons';
const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.getsummons';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleDownload = (platform: 'ios' | 'android') => {
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', platform === 'ios' ? 'click_download_ios' : 'click_download_android');
    }
    window.open(platform === 'ios' ? IOS_APP_STORE_URL : ANDROID_PLAY_STORE_URL, '_blank');
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/90 backdrop-blur-xl border-b border-gray-100 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <AppLogo
          text="Summons"
          iconName="SparklesIcon"
          size={64}
        />

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-600">
          <a href="#how-it-works" className="hover:text-foreground transition-colors">How It Works</a>
          <a href="#categories" className="hover:text-foreground transition-colors">Services</a>
          <a href="#faq" className="hover:text-foreground transition-colors">FAQ</a>
          <a
            href="https://app.getsummons.com"
            className="hover:text-foreground transition-colors"
            onClick={() => {
              if (typeof window !== 'undefined' && (window as any).gtag) {
                (window as any).gtag('event', 'click_use_web');
              }
            }}
          >
            Web App
          </a>
        </div>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => handleDownload('ios')}
            className="flex items-center gap-2 px-4 py-2 rounded-xl bg-foreground text-white text-sm font-semibold store-btn"
          >
            <Icon name="DevicePhoneMobileIcon" size={16} className="text-white" />
            App Store
          </button>
          <button
            onClick={() => handleDownload('android')}
            className="flex items-center gap-2 px-4 py-2 rounded-xl bg-primary text-white text-sm font-semibold cta-btn"
          >
            <Icon name="DevicePhoneMobileIcon" size={16} className="text-white" />
            Google Play
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <Icon name={menuOpen ? 'XMarkIcon' : 'Bars3Icon'} size={22} className="text-foreground" />
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-b border-gray-100 px-4 pb-4 space-y-3">
          <a href="#how-it-works" className="block py-2 text-sm font-medium text-gray-600" onClick={() => setMenuOpen(false)}>How It Works</a>
          <a href="#categories" className="block py-2 text-sm font-medium text-gray-600" onClick={() => setMenuOpen(false)}>Services</a>
          <a href="#faq" className="block py-2 text-sm font-medium text-gray-600" onClick={() => setMenuOpen(false)}>FAQ</a>
          <div className="flex gap-2 pt-2">
            <button
              onClick={() => { handleDownload('ios'); setMenuOpen(false); }}
              className="flex-1 py-2.5 rounded-xl bg-foreground text-white text-sm font-semibold text-center"
            >
              App Store
            </button>
            <button
              onClick={() => { handleDownload('android'); setMenuOpen(false); }}
              className="flex-1 py-2.5 rounded-xl bg-primary text-white text-sm font-semibold text-center"
            >
              Google Play
            </button>
          </div>
        </div>
      )}
    </header>
  );
}